import React from 'react';
import PropTypes from 'prop-types';

import { ExpandButtonContainer, AtlasButtonImg } from './styles';

const ExpandModalButton = ({ showButton, handleShow }) => (
  <ExpandButtonContainer
    showButton={showButton}
    title="Open Modal"
    role="button"
    onClick={handleShow}
    onKeyPress={() => {}}
    tabIndex={0}
  >
    <AtlasButtonImg
      src="/maps-buttons/circuflecha_blanco.svg"
      alt="Open Modal"
      numberOfButtonsLeft={0}
      showButton={showButton}
    />
  </ExpandButtonContainer>
);
ExpandModalButton.defaultProps = {
  showButton: true,
  handleShow: () => console.error('Show function not found')
};

ExpandModalButton.propTypes = {
  showButton: PropTypes.bool,
  handleShow: PropTypes.func
};

export default ExpandModalButton;
